import { defineComponent as E, ref as c, onMounted as B, watch as r, createElementBlock as C, openBlock as D, withDirectives as w, createElementVNode as O, normalizeClass as S, vModelText as A } from "vue";
import { KEYCODE as t } from "./highrise490.mjs";
const P = { class: "hr-otp-field-wrapper" }, _ = ["disabled", "placeholder"], R = /* @__PURE__ */ E({
  __name: "SingleInput",
  props: {
    focus: {
      type: Boolean
    },
    value: {
      type: String,
      default: null
    },
    fieldClass: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    placeholder: {
      type: String
    }
  },
  emits: ["onChange", "onKeydown", "onPaste", "onFocus", "onBlur"],
  setup(u, { emit: d }) {
    const i = u, o = c(""), a = c(null), s = d, f = () => {
      s("onBlur");
    }, p = (e) => {
      e.preventDefault();
    }, h = () => {
      o.value.toString().length > 1 ? o.value = o.value.toString().slice(0, 1) : o.value = o.value.toString(), s("onChange", o.value);
    }, m = () => {
      s("onFocus");
    }, v = (e) => {
      s("onPaste", e);
    }, g = (e) => {
      const n = e, l = n.which ? n.which : n.keyCode;
      y(l) || l === t.BACKSPACE || l === t.V || l === t.DELETE || l === t.RIGHT_ARROW || l === t.LEFT_ARROW || l === t.TAB ? s("onKeydown", e) : n.preventDefault();
    }, y = (e) => e >= t.ZERO && e <= t.NINE || e >= t.NUMPAD_0 && e <= t.NUMPAD_9;
    return B(() => {
      i.focus && a.value.focus();
    }), r(
      () => i.focus,
      (e, n) => {
        e !== n && a.value && i.focus && (a.value.focus(), a.value.select());
      }
    ), r(
      () => i.value,
      (e, n) => {
        e !== n && (o.value = e);
      }
    ), (e, n) => (D(), C("div", P, [
      w(O("input", {
        ref_key: "input",
        ref: a,
        "onUpdate:modelValue": n[0] || (n[0] = (l) => o.value = l),
        class: S(["hr-otp-field-input", u.fieldClass]),
        type: "number",
        min: "0",
        max: "9",
        maxlength: "1",
        pattern: "[0-9]",
        autofocus: "false",
        disabled: u.disabled,
        placeholder: u.placeholder,
        onDragstart: p,
        onInput: h,
        onKeydown: g,
        onPaste: v,
        onFocus: m,
        onBlur: f
      }, null, 42, _), [
        [A, o.value]
      ])
    ]));
  }
});
export {
  R as default
};
